import React from "react";
import { Select } from "antd";

import { ChannelOptions } from "../../tab-pages/video-resource-page";

export const ChannelSelect = (props) => {
  return (
    <Select {...props}>
      {ChannelOptions.map(({ value, label }) => (
        <Select.Option key={value} value={value}>
          {label}
        </Select.Option>
      ))}
    </Select>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/form-item/channel-select.js